


{
  "familyId": "TIJD-DIGITAAL",
  "questions": [
    {
      "id": "TIJD-DIGITAAL-001",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Een treinmachinist begint zijn dienst om 00:00. Wat betekent die tijd?",
      "options": ["middernacht", "12 uur 's middags", "1 uur 's nachts", "24 uur"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "digitalClock", "data": { "hours": 0, "minutes": 0, "format": "24h" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "24-uurs notatie", "content": "Bij de 24-uurs klok begint de dag bij 00:00 (middernacht). De dag loopt van 00:00 tot 23:59, daarna begint een nieuwe dag weer bij 00:00." } }],
      "conceptId": "digital_midnight",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.78,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "tijd.00-vs-12-verward", "label": "Verwart 00:00 met 12:00", "optionIndex": 1 },
          { "id": "tijd.middernacht-vs-01:00", "label": "Denkt dat 00:00 = 1 uur 's nachts", "optionIndex": 2 },
          { "id": "tijd.24:00-bestaat-niet", "label": "Gebruikt 24 uur i.p.v. 00", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "00:00 = middernacht, het begin van een nieuwe dag. De dag loopt van 00:00 tot 23:59; daarna springt de klok naar 00:00.",
        "solutionSteps": ["00 uur = begin van een nieuwe dag", "00 minuten = precies op het hele uur", "00:00 = middernacht"],
        "distractorExplanations": {
          "0": "Goed! 00:00 = middernacht.",
          "1": "12:00 is midden op de dag, dat is 12 uur ná middernacht.",
          "2": "01:00 is 1 uur 's nachts — dat is 1 uur ná middernacht. Middernacht zelf is 00:00.",
          "3": "Op de 24-uurs klok schrijven we nooit 24:00; na 23:59 springt de klok naar 00:00."
        }
      }
    },
    {
      "id": "TIJD-DIGITAAL-002",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "fill_in",
      "question": "Een piloot plant een vlucht om 10 uur 's avonds. Hoe schrijf je dit op de digitale klok (24-uurs notatie)? Typ in formaat uu:mm.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["22:00", "22.00"],
        "caseSensitive": false,
        "placeholder": "uu:mm"
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Avondtijden omrekenen", "content": "Bij tijden 's middags/'s avonds tel je 12 uur bij het gewone uur. 10 uur 's avonds = 10 + 12 = 22:00." } }],
      "conceptId": "analog_to_digital_evening_fill",
      "variantIndex": 2,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.78,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "10 uur 's avonds = 10 + 12 = 22. Vergeet de twee cijfers voor de minuten niet: 22:00.",
        "solutionSteps": ["'s Avonds: tel 12 uur bij het gewone uur", "10 + 12 = 22", "Minuten = 00", "Antwoord: 22:00"]
      }
    },
    {
      "id": "TIJD-DIGITAAL-003",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "fill_in",
      "question": "Een kok moet om 18:30 het avondeten serveren. Hoe spreek je deze tijd uit in 'gewoon Nederlands'? Schrijf bijvoorbeeld: 'half 7 's avonds'.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["half 7 's avonds", "half zeven 's avonds", "half 7 s avonds", "half zeven s avonds", "half 7 savonds", "half zeven savonds", "half 7 ’s avonds", "half zeven ’s avonds"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [{ "type": "digitalClock", "data": { "hours": 18, "minutes": 30 } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Digitaal naar analoog", "content": "Trek 12 af van uren boven 12: 18 − 12 = 6. Dus 6:30 's avonds. Bij 'half' kijk je naar het vólgende uur: 6:30 = half 7." } }],
      "conceptId": "digital_to_analog_evening_fill",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "18 − 12 = 6, dus 6 uur 's avonds. :30 is 'half', en bij 'half' kijk je vóóruit naar het volgende uur: 6:30 = half 7 's avonds.",
        "solutionSteps": ["18 − 12 = 6 → 6 uur 's avonds", ":30 = half", "Half kijkt naar volgend uur: 6:30 = half 7", "Antwoord: half 7 's avonds"]
      }
    },
    {
      "id": "TIJD-DIGITAAL-004",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Een buschauffeur vertrekt om 14:45. Hoe lees je deze tijd af?",
      "options": ["kwart voor 3 's middags", "kwart over 2 's middags", "kwart voor 2 's middags", "kwart over 3 's middags"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "digitalClock", "data": { "hours": 14, "minutes": 45 } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Kwart voor aflezen", "content": "14 − 12 = 2 → 2:45 's middags. Bij :45 zeg je 'kwart voor het volgende uur' → kwart voor 3." } }],
      "conceptId": "digital_to_analog_quarter",
      "variantIndex": 4,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.kwart-voor-over-verward", "label": "Verwart :45 met kwart over", "optionIndex": 1 },
          { "id": "tijd.half-voor-over-blijft-op-uur", "label": "Houdt het huidige uur aan bij 'kwart voor'", "optionIndex": 2 },
          { "id": "tijd.kwart-voor-over-verward", "label": "Verwart kwart voor met kwart over én springt naar volgend uur", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "14:45 = 2:45 's middags. Bij :45 (= 'kwart voor') kijk je naar het vólgende uur: 2:45 = kwart voor 3.",
        "solutionSteps": ["14 − 12 = 2 → 2 uur 's middags", ":45 = kwart voor", "Kwart voor kijkt naar volgend uur: kwart voor 3", "Antwoord: kwart voor 3 's middags"],
        "distractorExplanations": {
          "0": "Goed! 14:45 = kwart voor 3 's middags.",
          "1": ":45 is kwart voor, niet kwart over. Kwart over = :15.",
          "2": "Bij 'kwart voor' kijk je naar het vólgende uur. 2:45 = kwart voor 3, niet kwart voor 2.",
          "3": ":45 is kwart voor, niet kwart over. En het is kwart voor 3, niet kwart over 3."
        }
      }
    },
    {
      "id": "TIJD-DIGITAAL-005",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "matching",
      "question": "Koppel elke gesproken tijd aan de juiste digitale klok-tijd.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "half 9 's ochtends", "right": "08:30" },
          { "left": "half 9 's avonds", "right": "20:30" },
          { "left": "kwart over 4 's middags", "right": "16:15" },
          { "left": "kwart voor 12 's nachts", "right": "23:45" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Half / kwart omrekenen", "content": "'Half X' = X − 0:30 → voor 's middags + 12. Kwart over X = X:15. Kwart voor X = (X−1):45." } }],
      "conceptId": "matching_gesproken_digitaal",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Half 9 's ochtends = 8:30 → 08:30. Half 9 's avonds = 8:30 + 12 → 20:30. Kwart over 4 's middags = 4:15 + 12 → 16:15. Kwart voor 12 's nachts = 11:45 + 12 → 23:45.",
        "solutionSteps": [
          "Half 9 's ochtends → 08:30",
          "Half 9 's avonds → 20:30",
          "Kwart over 4 's middags → 16:15",
          "Kwart voor 12 's nachts → 23:45"
        ]
      }
    },
    {
      "id": "TIJD-DIGITAAL-006",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "true_false_series",
      "question": "Beoordeel of elke uitspraak klopt.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "13:00 betekent 1 uur 's middags.", "isTrue": true },
          { "text": "Op een digitale 24-uurs klok bestaat de tijd 24:00.", "isTrue": false },
          { "text": "07:30 betekent half 8 's ochtends.", "isTrue": true },
          { "text": "21:15 betekent kwart voor 9 's avonds.", "isTrue": false },
          { "text": "19:45 betekent kwart voor 8 's avonds.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Belangrijke regels", "content": "Boven 12: trek 12 af voor 'gewone' uur. :15 = kwart over. :30 = half (volgend uur!). :45 = kwart voor (volgend uur!). 24:00 bestaat niet — dat is 00:00." } }],
      "conceptId": "digital_tf_series",
      "variantIndex": 6,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "13:00 = 1 's middags ✓. 24:00 bestaat niet (dat wordt 00:00) ✗. 07:30 = half 8 ✓. 21:15 = kwart over 9, niet kwart voor 9 ✗. 19:45 = kwart voor 8 ✓.",
        "solutionSteps": [
          "13:00 → 1 uur 's middags → WAAR",
          "24:00 → bestaat niet → ONWAAR",
          "07:30 → half 8 's ochtends → WAAR",
          "21:15 → kwart over 9 (niet voor) → ONWAAR",
          "19:45 → kwart voor 8 's avonds → WAAR"
        ]
      }
    },
    {
      "id": "TIJD-DIGITAAL-007",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "ordering",
      "question": "Een logistiek planner sorteert leveringen. Zet deze tijden op volgorde van vroeg naar laat op dezelfde dag.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["14:30", "09:15", "16:45", "11:00"],
        "correctOrder": [1, 3, 0, 2]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Tijden vergelijken", "content": "Kijk eerst naar het uur, daarna naar de minuten. Op een 24-uurs klok is een hoger uur altijd later op dezelfde dag.", "icon": "lightbulb" } }],
      "conceptId": "time_ordering",
      "variantIndex": 7,
      "citoDifficulty": 0.26,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Sorteer op uur (en daarna minuten): 09:15 → 11:00 → 14:30 → 16:45.",
        "solutionSteps": ["Uren: 9, 11, 14, 16", "Laagste eerst: 09:15", "Daarna 11:00, 14:30, 16:45", "Volgorde: 09:15 → 11:00 → 14:30 → 16:45"]
      }
    },
    {
      "id": "TIJD-DIGITAAL-008",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "fill_in",
      "question": "De film begint om 20:15 en duurt 1 uur en 50 minuten. Hoe laat is de film afgelopen? Typ in formaat uu:mm.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["22:05", "22.05"],
        "caseSensitive": false,
        "placeholder": "uu:mm"
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Tijd optellen", "content": "Tel eerst de uren op: 20 + 1 = 21. Dan de minuten: 15 + 50 = 65 minuten = 1 uur + 5 minuten. Dus 21:00 + 1:05 = 22:05." } }],
      "conceptId": "digital_tijd_optellen",
      "variantIndex": 8,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Start 20:15. + 1 uur = 21:15. + 50 minuten: 21:15 + 50 = 22:05 (want 15 + 50 = 65 minuten = 1 uur 5 minuten).",
        "solutionSteps": ["20:15 + 1 uur = 21:15", "21:15 + 50 min: 15 + 50 = 65", "65 min = 1 uur 5 min", "21:15 + 0:50 = 22:05"]
      }
    },
    {
      "id": "TIJD-DIGITAAL-009",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "multiple_choice",
      "question": "Een verpleegkundige leest op het rooster: '06:50'. Wat klopt?",
      "options": [
        "10 voor 7 's ochtends",
        "10 over 6 's ochtends",
        "10 voor 6 's avonds",
        "kwart voor 7 's ochtends"
      ],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "digitalClock", "data": { "hours": 6, "minutes": 50 } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Minuten boven 30 → kijk vooruit", "content": ":50 = 10 minuten vóór het volgende hele uur. 6:50 = 10 voor 7." } }],
      "conceptId": "digital_minuten_voor",
      "variantIndex": 9,
      "citoDifficulty": 0.34,
      "citoDiscrimination": 0.74,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "tijd.minuten-voor-na-half-verward", "label": "Leest :50 als 'over' i.p.v. 'voor'", "optionIndex": 1 },
          { "id": "tijd.dagdeel-verward", "label": "Verwart 's ochtends met 's avonds", "optionIndex": 2 },
          { "id": "tijd.kwart-vs-tien-voor", "label": "Verwart 10 voor met kwart voor", "optionIndex": 3 }
        ]
      },
      "feedback": {
        "explanationText": "06:50 = 6 uur en 50 minuten. Omdat 50 dichter bij het volgende hele uur ligt, lezen we het als '10 voor 7'.",
        "solutionSteps": ["06 = 6 uur 's ochtends", ":50 → 60 − 50 = 10 minuten vóór 7", "Antwoord: 10 voor 7 's ochtends"],
        "distractorExplanations": {
          "0": "Goed! 06:50 = 10 voor 7 's ochtends.",
          "1": "06:50 is bijna 7 uur, niet net na 6. 10 over 6 zou 06:10 zijn.",
          "2": "Tijden onder 12:00 zijn 's ochtends, niet 's avonds.",
          "3": "Kwart voor 7 zou 06:45 zijn, niet 06:50."
        }
      }
    },
    {
      "id": "TIJD-DIGITAAL-010",
      "familyId": "TIJD-DIGITAAL",
      "module": "Tijd",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "klokkijken",
      "subSkill": "klok_digitaal",
      "questionType": "categorize",
      "question": "Sorteer deze tijden: ochtend (00:00–11:59), middag (12:00–17:59) of avond/nacht (18:00–23:59)?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Ochtend", "Middag", "Avond/nacht"],
        "items": [
          { "text": "07:45", "correctCategory": 0 },
          { "text": "14:00", "correctCategory": 1 },
          { "text": "22:30", "correctCategory": 2 },
          { "text": "11:55", "correctCategory": 0 },
          { "text": "17:00", "correctCategory": 1 },
          { "text": "19:15", "correctCategory": 2 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Dagdelen op 24-uurs klok", "content": "Ochtend: 00:00–11:59. Middag: 12:00–17:59. Avond/nacht: 18:00–23:59. Let op de grens: 12:00 is al middag.", "icon": "lightbulb" } }],
      "conceptId": "digital_dagdelen_categorize",
      "variantIndex": 10,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "07:45 en 11:55 zijn 's ochtends (vóór 12:00). 14:00 en 17:00 zijn 's middags. 22:30 en 19:15 zijn 's avonds.",
        "solutionSteps": [
          "07:45 → ochtend",
          "14:00 → middag",
          "22:30 → avond/nacht",
          "11:55 → ochtend (net voor 12:00)",
          "17:00 → middag",
          "19:15 → avond/nacht"
        ]
      }
    }
  ]
}


